import hoc, { IconProps } from 'bloko/blocks/icon/hoc';

const TelegramScaleMediumAppearanceOutlined = hoc(
    (props: IconProps) => (
        <svg width={25} height={24} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M0.807588 11.8508C2.88506 10.6572 5.2042 9.66064 7.37103 8.65994C11.0985 7.01963 14.8412 5.41026 18.6215 3.90921C19.3576 3.65337 20.6786 3.40371 20.8086 4.54058C20.7375 6.14995 20.4461 7.749 20.2451 9.34805C19.7374 12.866 19.1495 16.3705 18.5768 19.877C18.3798 21.0449 16.9766 21.6494 16.079 20.9015C13.9223 19.3818 11.7483 17.8777 9.61908 16.323C8.9205 15.5833 9.56831 14.5218 10.1907 13.9946C11.9677 12.1686 13.8522 10.617 15.5357 8.69708C15.9906 7.55299 14.6483 8.51758 14.2056 8.81263C11.7727 10.5602 9.39976 12.4151 6.83592 13.9502C5.52607 14.7033 3.99894 14.0606 2.68909 13.6407C1.51531 13.1342 -0.20475 12.6235 0.807588 11.8508V11.8508Z"
                stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    'Telegram'
);
export default TelegramScaleMediumAppearanceOutlined;
